<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html,body{
  padding: 0;
  margin: 0;
  background-color: #1C2357;
}
</style>



// WEBPACK FOOTER //
// src/App.vue